var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-host-mobile"},[_c('MHeader'),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('MFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }